/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const interviewBadgeStateSchema = z.enum([
	'confirmed',
	'pending',
	'completed',
	'no_show',
	'expired',
	'cancelled',
])

export type InterviewBadgeStateSchema = z.infer<typeof interviewBadgeStateSchema>
